<script setup lang="ts">
  import { BaseModal } from '@/shared/ui/components'

  withDefaults(
    defineProps<{
      loading?: boolean
    }>(),
    {
      loading: false,
    },
  )

  const emit = defineEmits<{
    (e: 'confirm'): void
    (e: 'discard'): void
  }>()

  const isOpen = defineModel<boolean>('show', { default: false })

  const { t } = useI18n()

  const handleConfirm = () => {
    emit('confirm')
  }

  const handleDiscard = () => {
    emit('discard')
    isOpen.value = false
  }
</script>

<template>
  <BaseModal
    v-model:show="isOpen"
    max-width="400px"
    body-class="ps-7 pt-2 pb-6"
    message="base_unsaved_changes_message"
    :loading="loading"
    @confirm="handleConfirm"
  >
    <template #header>
      <div class="flex items-center gap-2">
        <i
          class="fa-solid fa-circle-info text-primary w-5 text-center text-lg leading-5"
          aria-hidden="true"
        />
        <h2 class="text-heading m-0 min-w-0 flex-1 text-lg! leading-7! font-semibold! tracking-tight!">
          {{ $t('base_unsaved_changes_title') }}
        </h2>
      </div>
    </template>

    <template #footer="{ confirm }">
      <footer class="flex items-center justify-end gap-1.5">
        <NButton
          class="min-w-25!"
          round
          secondary
          size="medium"
          :disabled="loading"
          @click="handleDiscard"
        >
          {{ t('base_unsaved_changes_discard') }}
        </NButton>
        <NButton
          class="min-w-25!"
          round
          size="medium"
          type="primary"
          :disabled="loading"
          :loading="loading"
          @click="confirm"
        >
          {{ t('base_unsaved_changes_save') }}
        </NButton>
      </footer>
    </template>
  </BaseModal>
</template>
